let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hYF3d")).then(() => parcelRequire('ih0Zd'));